var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimboloVirtueyes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 399,
    viewBox: "0 0 400 399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.6 0C309.8 0 399.1 89.3 399.1 199.5C399.1 309.7 309.8 399 199.6 399C89.4 399 0 309.8 0 199.6C0 89.4 89.4 0 199.6 0ZM15.4 191.6L191.6 15.5C196 11.1 203.2 11.1 207.6 15.5L383.7 191.6C388.1 196 388.1 203.2 383.7 207.6L207.6 383.7C203.2 388.1 196 388.1 191.6 383.7L15.4 207.6C11 203.2 11 196 15.4 191.6ZM199.6 96.2C256.7 96.2 303 142.5 303 199.6C303 256.7 256.7 303 199.6 303C142.5 303 96.2 256.7 96.2 199.6C96.2 142.5 142.5 96.2 199.6 96.2Z",
    fill: "#3EBECD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimboloVirtueyes);
export default __webpack_public_path__ + "static/media/simbolo-virtueyes.1cda493a778e8c91d869b18e0dd6c0d2.svg";
export { ForwardRef as ReactComponent };